import { Button, Fade, Tooltip } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { getButtonSx, mergeSx } from "./buttonStyles";

export const ButtonIconOnly = ({
  size = "sm",
  sx,
  sxButton,
  iconOnly,
  tooltip,
  children,
  ...props
}: IButtons) => {
  const button = (
    <Button
      {...props}
      sx={mergeSx(
        (theme) => getButtonSx(theme, "iconOnly", size),
        sx,
        sxButton,
      )}
    >
      {iconOnly ?? children}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip} TransitionComponent={Fade}>
      {button}
    </Tooltip>
  ) : (
    button
  );
};
